import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgTelegram = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.4 17.791l-.11.11c-2.139 2.148-2.253 2.255-2.784 2.255-.493 0-.808-.25-1.087-.626a2.55 2.55 0 01-.284-.492l-2.089-5.781.005-.088-3.667-1.195s-.517-.21-.351-.686c.034-.099.103-.182.31-.327.961-.67 17.78-6.715 17.78-6.715s.476-.16.756-.053c.128.048.21.103.28.304.024.073.039.228.037.383-.001.11-.015.214-.025.376-.102 1.653-3.168 13.989-3.168 13.989s-.183.721-.84.746c-.24.01-.53-.04-.878-.339-.62-.533-1.97-1.501-3.317-2.437-.192.196-.383.389-.569.576zm-.936-1.611c-.86-.587-1.58-1.07-1.91-1.291a.188.188 0 01-.082-.133c-.013-.07.062-.155.062-.155l6.683-6.338s-5.917 3.202-8.349 4.572l-.007.151 1.795 4.98c.351-.332.814-.786 1.36-1.334l.107-.108.34-.344z"
      clipRule="evenodd"
    />
  </svg>
));
SvgTelegram.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgTelegram;
